module.exports = __webpack_public_path__ + "img/success.59ae8e4c.svg";